import { API } from '@/components/api/shared/api'
import { registrationApiFormatter } from '@/components/api/registrationApi/apiFormatter'
import { RegistrationResponse, RegistrationApiFormatterInput } from '@/components/api/registrationApi/types'
import { ServiceType, SERVICE_TYPES } from '@/components/constants'
import { markLpRegistrationFlag } from '@/components/utils/lpRegistrationFlag'

export const fetchRegistration = async (
    data: RegistrationApiFormatterInput,
    service: ServiceType = SERVICE_TYPES.FOODSLABO
): Promise<RegistrationResponse> => {
    const registrationApiFormattedData = registrationApiFormatter(data)
    const csrfToken = document.querySelector<HTMLMetaElement>(
        'meta[name="csrf-token"]'
    )?.content
    if (!csrfToken) {
        throw new Error('CSRF token not found')
    }
    try {
        const response = await fetch(API.ENDPOINTS.SIGNUP(service), {
            method: 'POST',
            headers: {
                'Content-Type': API.HEADERS.CONTENT_TYPE,
                Accept: API.HEADERS.CONTENT_TYPE,
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(registrationApiFormattedData)
        })

        if (!response.ok) {
            const errorMessage = await response.text()
            return Promise.reject(new Error(errorMessage))
        }

        markLpRegistrationFlag()

        const responseData = await response.json() as RegistrationResponse
        return responseData
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Registration failed: ${error.message}`)
        }
        throw new Error('Registration failed: Unknown error')
    }
}
